import { colors } from '../../../../../../colors';
import ColoredCheckbox from '../../../../../../components/ColoredCheckbox';

interface Props {
  useTakeProfitTransactions: boolean;
  transactionTypeToggleValues: {
    core: boolean;
    takeProfit: boolean;
    stopLoss: boolean;
  };
  setTransactionTypeToggleValues: React.Dispatch<
    React.SetStateAction<{
      core: boolean;
      takeProfit: boolean;
      stopLoss: boolean;
    }>
  >;
}

const TransactionTypeToggles = (props: Props) => {
  const {
    useTakeProfitTransactions,
    transactionTypeToggleValues,
    setTransactionTypeToggleValues,
  } = props;

  const coreTransactionsColor = transactionTypeToggleValues.core
    ? colors.white
    : colors.gray;

  const takeProfitTransactionsColor = transactionTypeToggleValues.takeProfit
    ? colors.yellow
    : colors.gray;

  const stopLossTransactionsColor = transactionTypeToggleValues.stopLoss
    ? colors.blue
    : colors.gray;

  return (
    <div
      style={{
        display: 'flex',
        columnGap: 40,
        justifyContent: 'center',
      }}
    >
      <div style={{ display: 'flex', columnGap: 4 }}>
        <ColoredCheckbox
          value={transactionTypeToggleValues.core}
          handleValueChange={() =>
            setTransactionTypeToggleValues((prev) => ({
              ...prev,
              core: !prev.core,
            }))
          }
          color={coreTransactionsColor}
          size={10}
        />
        <span
          className="profit-chart-options-label"
          style={{
            color: coreTransactionsColor,
          }}
        >
          Core Transactions
        </span>
      </div>
      {useTakeProfitTransactions && (
        <>
          <div style={{ display: 'flex', columnGap: 4 }}>
            <ColoredCheckbox
              value={transactionTypeToggleValues.takeProfit}
              handleValueChange={() =>
                setTransactionTypeToggleValues((prev) => ({
                  ...prev,
                  takeProfit: !prev.takeProfit,
                }))
              }
              color={takeProfitTransactionsColor}
              size={10}
            />
            <span
              className="profit-chart-options-label"
              style={{
                color: takeProfitTransactionsColor,
              }}
            >
              TakeProfit Transactions
            </span>
          </div>
          <div style={{ display: 'flex', columnGap: 4 }}>
            <ColoredCheckbox
              value={transactionTypeToggleValues.stopLoss}
              handleValueChange={() =>
                setTransactionTypeToggleValues((prev) => ({
                  ...prev,
                  stopLoss: !prev.stopLoss,
                }))
              }
              color={stopLossTransactionsColor}
              size={10}
            />
            <span
              className="profit-chart-options-label"
              style={{
                color: stopLossTransactionsColor,
              }}
            >
              stopLoss Transactions
            </span>
          </div>
        </>
      )}
    </div>
  );
};

export default TransactionTypeToggles;
